import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import { useFlags } from 'launchdarkly-react-client-sdk';

// Constants
import { WorkspaceIntrolModalData } from './WorkspaceIntroModalSlides';

// Utils
import { getCurrentMoment, convertMomentToUnix } from 'Shared/utils/DateTime.utils';

// Actions
import * as UsersActions from 'Shared/actions/Users.actions';

// Selectors
import { getUserFlag } from 'Shared/selectors/user';

// Hooks
import { useToggle } from 'Shared/utils/hooks';
import { useCurrentUser } from 'Shared/utils/hooks/use-current-user';
import { useApp } from 'Shared/utils/hooks/use-app';
import { useWorkspace } from 'Shared/utils/hooks/use-workspace';

// Components
import NewFeatureCarouselModal from '../NewFeatureCarouselModal/NewFeatureCarouselModal';

const WorkspaceIntroModal = () => {
  const dispatch = useDispatch();
  const { newWorkspaceAgendaBuilder } = useFlags();

  const [isOpen, toggleIsOpen] = useToggle(false);

  const { isZoom } = useApp();
  const { isPersonal: isPersonalWorkspace } = useWorkspace();
  const { user } = useCurrentUser();

  const hasSeenFlag = Boolean(useSelector(state => getUserFlag(state, { flag: 'seen_workspace_intro_modal' })));

  useEffect(() => {
    if (isOpen) {
      const timestamp = convertMomentToUnix(getCurrentMoment());
      dispatch(UsersActions.updateUserFlag('seen_workspace_intro_modal', timestamp));
    }
  }, [isOpen]);

  // we haven't seen the modal, open it
  useEffect(() => {
    const now = moment();
    const onboardingCompleteTime = user.onboarding?.completed_at;
    const isOnboardingCompletedlessThan24Hours =
      onboardingCompleteTime && now.diff(moment.unix(onboardingCompleteTime), 'hours') < 24;
    if (
      !isZoom &&
      !hasSeenFlag &&
      isOnboardingCompletedlessThan24Hours &&
      !isPersonalWorkspace &&
      !newWorkspaceAgendaBuilder
    )
      toggleIsOpen();
  }, []);

  // do not render the modal if we've seen it, or
  // if this is the first time seeing the modal
  // which will hapen when it's been opened
  if (!isOpen) return null;

  return (
    <NewFeatureCarouselModal
      isOpen={isOpen}
      toggleIsOpen={toggleIsOpen}
      data={WorkspaceIntrolModalData}
      zIndex={1061}
    />
  );
};

export default WorkspaceIntroModal;
